import React, { FC, memo, useState } from 'react';
import FnThumbnail from '../../../../components/elements/FnThumbnail/index';
import { DivImageBlock, DivExtendedName } from '../../styles';
import FnCheckbox from '../../../../components/elements/FnCheckbox';

type TProps = {
  extendedName: string;
  id: string;
  uri: string;
  onCheck: (id: string, value: boolean) => void;
};

const SameArtworkItem: FC<TProps> = ({ extendedName, id, uri, onCheck }) => {
  const [value, setValue] = useState(false);

  const handleCheck = (value: boolean) => {
    setValue(value);
    onCheck(id, value);
  };

  return (
    <DivImageBlock>
      <FnCheckbox name={id} value={value} onChange={handleCheck} />
      <FnThumbnail src={uri} className="mockup-thumbnail" isReview={false} />
      <DivExtendedName checkboxBlock>{extendedName}</DivExtendedName>
    </DivImageBlock>
  );
};

export default memo(SameArtworkItem);
